var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.91 12.857c-1.33 0-2.41-.833-2.41-2.054C2.5 9.58 3.58 8.59 4.91 8.59c.091 0 .18.004.269.013v-.013h.033a3.647 3.647 0 0 1-.033-.492c0-2.172 1.918-3.932 4.285-3.932 1.603 0 3 .807 3.736 2.003.18-.024.363-.037.55-.037 2.071 0 3.75 1.54 3.75 3.44 0 1.565-1.138 2.758-2.695 3.15m-4.923 3.11v-5.645m0 0-2.46 2.328m2.46-2.328 2.462 2.328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "m2.373 4.922.555.817.817.555-.817.556-.555.817-.556-.817L1 6.294l.817-.555.556-.817ZM14.373 14.922l.555.817.817.555-.817.556-.555.817-.556-.817-.817-.556.817-.555.556-.817Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m14.65 0 .635 1.717 1.718.636-1.718.635-.635 1.718-.636-1.718-1.717-.635 1.717-.636L14.65 0Z"
  })));
};
export default SvgUpload;